export const permissionsMixin = {
  data() {
    return {
      permissions: {}
    }
  },
  computed: {
    moduleMap() {
      if (!this.permissions?.role?.permissions?.length) return {};
      
      const map = {};
      this.permissions.role.permissions.forEach(perm => {
        map[perm.module.name] = perm.module_id;
      });
      return map;
    }
  },
  methods: {
    getPermission(moduleName, action) {
      if (this.permissions?.role?.permissions?.length === 0) return false;
      
      const moduleId = this.moduleMap[moduleName];
      if (!moduleId) return false;
      
      const perm = this.permissions.role.permissions.find(p => p.module_id === moduleId);
      return perm?.[action] === 1;
    },
    setPermissions(userData) {
      this.permissions = userData;
    }
  }
}
